<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说ID">
              <el-input v-model="queryParams.id" @change="search" placeholder="请输入小说ID" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说名称">
              <el-input v-model="queryParams.name" @change="search" placeholder="请输入小说名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说状态">
              <el-select v-model="queryParams.visible" @change="search" @clear="search" placeholder="请选择小说状态" clearable
                class="w100">
                <el-option label="下架" value="0"></el-option>
                <el-option label="上架" value="1"></el-option>
                <el-option label="入库" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="自然流量">
              <el-select v-model="queryParams.is_open_zrll" @change="search" @clear="search" placeholder="请选择自然流量"
                clearable class="w100">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="渠道是否可见">
              <el-select v-model="queryParams.cansee" @change="search" @clear="search" placeholder="请选择渠道是否可见" clearable
                class="w100">
                <el-option label="不可见" value="0"></el-option>
                <el-option label="可见" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="来源">
              <el-select v-model="queryParams.source" @change="search" @clear="search" placeholder="请选择来源" clearable
                class="w100">
                <el-option label="自制" value="0"></el-option>
                <el-option label="版权引入" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button size="medium" @click="addNoNe">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="medium"
        :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }" :cell-style="{ textAlign: 'center' }"
        border v-loading="loading">
        <el-table-column label="ID" width="80">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="封面" width="120">
          <template slot-scope="scope">
            <el-image style="width: 80px; height: 80px" :src="scope.row.full_cover"
              :preview-src-list="[scope.row.full_cover]" fit="cover">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="小说名称" width="130">
          <template slot-scope="scope">
            {{ scope.row.name }}
            <!-- <el-link type="primary" @click="AddVideo(scope.row)"></el-link> -->
          </template>
        </el-table-column>
       
        <el-table-column prop="name" label="章节总数">
          <template slot-scope="scope">{{ scope.row.chapter_total||0 }}章</template>
        </el-table-column>
        <el-table-column prop="name" label="小说状态" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.visible == 0">下架</span>
            <span v-if="scope.row.visible == 1">上架</span>
            <span v-if="scope.row.visible == 2">入库</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="上架时间" width="190">
          <template slot-scope="scope">
            <span v-if="scope.row.onself_time > currentTime" style="color: red">{{ scope.row.onself_time ?
              scope.row.onself_time : scope.row.created_at }}</span>
            <span v-else>{{ scope.row.onself_time ? scope.row.onself_time : scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="剧情描述" width="120">
          <template slot-scope="scope">
            <el-tooltip placement="bottom">
              <div slot="content" v-html="scope.row.description_all"></div>
              <span class="description-span">{{ scope.row.description }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="审核状态" width="150">
          <template slot-scope="scope">
           
           <div style="margin-top: 6px;">
            微信：<el-tag type="info" v-if="scope.row.audit_status_wx == 0">未审核</el-tag>
            <el-tag type="warning" v-else-if="scope.row.audit_status_wx == 1">审核中</el-tag>
            <el-tag type="success" v-else-if="scope.row.audit_status_wx == 2 || scope.row.drama_id != null">审核通过</el-tag>
            <el-tag type="danger" v-else-if="scope.row.audit_status_wx == 3">审核拒绝</el-tag>
            <el-tag type="info" v-else>未审核</el-tag>
           </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="来源" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.source == 0">自制</span>
            <span v-if="scope.row.source == 1">版权引入</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="连载状态" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">连载</span>
            <span v-if="scope.row.status == 1">完结</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="追书人数" width="150">
          <template slot-scope="scope">
            <el-tooltip placement="bottom" v-if="showWeight[scope.$index]">
              <div slot="content" v-html="clickText"></div>
              <span class="description-span" @click="setToNumber(scope.$index,scope.row.id)">{{ scope.row.follows_count }}</span>
            </el-tooltip>
            <el-input class="custom-input" v-if="!showWeight[scope.$index]" v-model="scope.row.follows_count"
              @blur="editShowWeight(scope.$index)" @change="editWeight(scope.$index, scope.row)"
              @input="validateInput(scope.row)" style="width: 60%;" maxlength="9" v-focus :min="0"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="渠道是否可见">
          <template slot-scope="scope">
            <span v-if="scope.row.cansee == 0">不可见</span>
            <span v-if="scope.row.cansee == 1">可见</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="是否开放自然流量">
          <template slot-scope="scope">
            <span v-if="scope.row.is_open_zrll == 0">否</span>
            <span v-if="scope.row.is_open_zrll == 1">是</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="name" label="评级">
          <template slot-scope="scope">
            <span v-if="scope.row.level == 1">S</span>
            <span v-if="scope.row.level == 2">A+</span>
            <span v-if="scope.row.level == 3">A</span>
            <span v-if="scope.row.level == 4">B</span>
            <span v-if="scope.row.level == 5">C</span>
          </template>
        </el-table-column> -->

        <el-table-column prop="name" label="免费章节">
          <template slot-scope="scope">{{ scope.row.free_chapter_total }}章</template>
        </el-table-column>
        <el-table-column prop="name" label="单章价格">
          <template slot-scope="scope">{{ scope.row.chapter_price }}</template>
        </el-table-column>
       
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="medium" @click="uploadVideo(scope.row)">上传</el-button>
              <el-button type="text" size="medium" @click="addDel(scope.row)">删除</el-button>
              <!-- <el-button type="text" size="medium" @click="addinfor(scope.row)">媒资信息</el-button> -->
            </div>
          </template>
        </el-table-column>

      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
        @pagination="getList" />
      <AddWorks v-if="AddWorksFlag" :AddWorksFlag="AddWorksFlag" @NoneDlog="NoneDlog" @AddOk="AddOk" :editID="editID">
      </AddWorks>
      <VideoPlay v-if="dialogTableVisible" :dialogTableVisible="dialogTableVisible" :videoObj="videoObj"
        @videoNone="videoNone"></VideoPlay>
      <information v-if="informationFlag" :informationFlag="informationFlag" @InfoNoneDlog="InfoNoneDlog"
        @InfoAddOk="InfoAddOk" :InfoeditID="InfoeditID"></information>
    </el-card>
  </div>
</template>

<script>
import { WorksListAPI } from '@/api/Works/WorksList';
import { processErrors } from "@/utils/errorHandler";
import VideoPlay from '@/components/VideoPlay/index'
import AddWorks from "./component/AddWorks.vue"
import information from "./component/Addinformation.vue"
export default {
  components: {
    AddWorks,
    VideoPlay,
    information
  },
  data() {
    return {
      clickText: "点击编辑",
      showWeight: {},
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        id:"",
        name: "",
        origin_name: "",
        book_name: "",
        cp_name: "",
        category_id: "",
        status: "",
        visible: "",
        is_open_zrll: "",
        cansee: "",
        source: ""
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
        type: "4"
      },
      tableData: [],
      editID: "",
      // 总条数
      total: 0,
      SearchFlag: false,
      AddWorksFlag: false,
      dialogTableVisible: false,
      videoObj: "",
      loading: true,
      currentTime: this.formatTime(new Date()),
      addFrom: {},
      informationFlag: false,
      InfoeditID: false
    };
  },
  created() {
    this.getList()
    this.getclassifyList()
  },
  methods: {
    editShowWeight(index) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 false
    },
    editWeight(index, data) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 true
      if (data.follows_count == null) {
        data.follows_count = 0
      }
      this.addFrom.follows_count=data.follows_count
      let api = WorksListAPI()
      api.WorksAdded(data).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "修改成功",
            type: 'success'
          });
          this.$emit('AddOk');
          this.getList();
        } else {
          processErrors(res);
        }
      })
    },
    setToNumber(index,id) {
      for (let i = 0; i < this.total; i++) {
        this.$set(this.showWeight, i, true);
      }
      this.$set(this.showWeight, index, false); // 设置特定行的状态为 false
      let api = WorksListAPI()
      api.detailsList(id).then(res => {
        if (res.code == 0) {
          this.addFrom = res.data
        } else {
          processErrors(res);
        }
      })
    },
    validateInput(row) {
      // 使用正则表达式验证输入值
      const regex = /^[0-9]*$/; // 只允许输入非负整数
      if (!regex.test(row.weight)) {
        // 如果输入不符合要求，重置为0
        row.weight = 0;
      }
    },
    formatTime(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },

    addput(name) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(name)
          .then(() => {
            // 复制成功
            this.$message.success('复制成功！');
          })
          .catch((err) => {
            // 复制失败
            this.$message.error('复制失败！');
          });
      } else {
        // 浏览器不支持剪贴板API
        this.$message.error('当前浏览器不支持复制到剪贴板功能！');
      }
    },

    getList() {
      this.loading = true;
      this.tableData = []
      let api = WorksListAPI()
      api.getWorksList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
          for (let i = 0; i < this.total; i++) {
            this.$set(this.showWeight, i, true);
          }
          this.tableData.forEach(item => {
            //展示全部
            let processedDescription = '';
            if (item.description != null) {
              for (let i = 0; i < item.description.length; i += 8) {
                processedDescription += item.description.slice(i, i + 8) + '<br/>';
              }
            }
            item.description_all = processedDescription

          });
        } else {
          processErrors(res);
        }
        this.loading = false;
      })
    },
    getclassifyList() {
      let api = WorksListAPI()
      api.classifyList(this.page).then(res => {
        if (res.code == 0) {
          this.appidList = res.data
        } else {
          processErrors(res);
        }
      })
    },
    // 打开搜索
    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    // 搜索
    search() {
      this.getList()
    },
    // 重置列表
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,

      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.AddWorksFlag = true
    },
    NoneDlog() {
      this.AddWorksFlag = false
    },
    AddOk() {
      this.editID = ""
      this.AddWorksFlag = false
      this.getList()
    },

    addEdit(row) {
      this.editID = row.id
      this.AddWorksFlag = true
    },

    addDel(row) {
      this.$confirm('确定删除该作品吗 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let api = WorksListAPI();
          let list = []
          list.push(row.id)
          let obj = {
            ids: list
          }
          api.DelList(obj).then(res => { // 假设 DelList 接受一个 id，而不是数组
            if (res.code == 0) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getList()
            } else {
              processErrors(res);
            }
          });
        })
        .catch(() => {
          this.$message({
            message: '取消删除',
            type: 'info' // 使用 'info' 类型表示提示信息
          });
        });
    },

    InfoNoneDlog() {
      this.informationFlag = false
    },

    InfoAddOk() {
      this.informationFlag = false
    },

    addinfor(row) {
      this.InfoeditID = row.id
      this.informationFlag = true
    },

    AddVideo(row) {
      this.videoObj = row
      this.dialogTableVisible = true
    },

    videoNone() {
      this.dialogTableVisible = false
    },

    uploadVideo(row) {
      this.$router.push({
        path: '/WorksManagement/bytedanceCatalog/component/UploadVideo',
        query: {
          id: row.id,
          episode_total: row.episode_total,
          name: row.name,
        },
      })
    },

  },
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector("input").focus();
      },
    },
  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }

  .custom-input ::v-deep .el-input__inner {
    text-align: center;
  }
}

.description-span {
  display: -webkit-box;
  /* 对于 Webkit 浏览器的兼容性 */
  -webkit-line-clamp: 3;
  /* 显示的行数 */
  -webkit-box-orient: vertical;
  /* 设置或检索伸缩盒对象的子元素的排列方式 */
  overflow: hidden;
  text-overflow: ellipsis;
  //white-space: nowrap;
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.Coimage {
  width: 50px;
  height: 50px;
}

.item {
  margin: 4px;
}
</style>